// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"0a903a0a","411":"6f036c21","430":"0fff5990","453":"848a24c5","541":"916bba46","641":"1e875551","648":"341daf7c","687":"a35e1eb8","699":"e76d6b76","818":"1ebcd743","823":"affaa0d3","900":"317633fa"}[chunkId] + ".chunk.js";
};